const PRIORITY_PAGES = [
    'Product/ProductPage',
    'Category/NthCategory',
    'Homepage/Homepage',
    'Search/Search',
    'Brands/BrandNthCategory',
    'ContentStore/ContentStoreNoNav',
    'ContentStore/ContentStore',
    'Campaigns/Referrer',
    'Basket/RwdBasketpage'
];

export default PRIORITY_PAGES;
